import React from 'react';
import PropTypes from 'prop-types';
import { StyledNavControl } from './style/NavControl.styled';

export const NavControl = ({ isOpen, onClick }) => {
    return (
        <StyledNavControl
            className="mobile-menu-control"
            type="checkbox"
            checked={isOpen}
            onChange={onClick}
        />
    );
};

NavControl.propTypes = {
    isOpen: PropTypes.bool,
    onClick: PropTypes.func
};
